import Link from "next/link";
import {
  FaXTwitter,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaFacebookF,
} from "react-icons/fa6";

const AboutContact = () => {
  return (
    <section className="mt-12 text-center">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
        Nous Contacter
      </h2>
      <p className="mt-2 text-gray-600 dark:text-gray-300">
        Vous avez des questions ? Envoyez-nous un e-mail à{" "}
        <Link
          href="mailto:contact@lesconcernes.com"
          className="text-blue-500 hover:underline"
        >
          contact@lesconcernes.com
        </Link>
      </p>

      <div className="mt-4 flex justify-center space-x-4">
        <SocialIcon
          href="https://www.facebook.com/profile.php?id=100092728413759"
          color="text-blue-600 hover:text-blue-800"
        >
          <FaFacebookF />
        </SocialIcon>
        <SocialIcon
          href="https://x.com/maglesconcernes?t=rERA2tJwLVRQktgypfQq4Q"
          color="text-black hover:text-gray-700"
        >
          <FaXTwitter />
        </SocialIcon>
        <SocialIcon
          href="https://www.linkedin.com/company/les-conc%C3%A9rnes/"
          color="text-blue-600 hover:text-blue-700"
        >
          <FaLinkedin />
        </SocialIcon>
        <SocialIcon
          href="https://www.youtube.com/@lesconcernes"
          color="text-red-600 hover:text-red-700"
        >
          <FaYoutube />
        </SocialIcon>
        <SocialIcon
          href="https://www.instagram.com/les_concernes/profilecard/?igsh=Y3drdzlhazh2bTB5"
          color="text-pink-600 hover:text-pink-700"
        >
          <FaInstagram />
        </SocialIcon>
        <SocialIcon
          href="https://tiktok.com"
          color="text-black hover:text-gray-700"
        >
          <FaTiktok />
        </SocialIcon>
      </div>
    </section>
  );
};

const SocialIcon = ({
  href,
  color,
  children,
}: {
  href: string;
  color: string;
  children: React.ReactNode;
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`${color} text-2xl`}
  >
    {children}
  </Link>
);

export default AboutContact;
